import { Component, ojs, app, v, state, payload } from "modular-openscriptjs";
import { eParse, cleanDispose, either, requireAuth } from "../../helpers";
import { tool } from "../../fotastart";
import { uc } from "../../declarations";
import { $e } from "../../ojs.events";

const h = app("h");
const broker = app("broker");

export default class DeliveryAddressList extends Component {
    modal = null;
    selectedAddressId = state(null);

    render(...args) {
        return h.div({ class: "d-none" }, ...args);
    }

    renderList(...args) {
        return h.div(
            { class: "container p-2" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4({ class: "fw-bold mb-0" }, "Saved Addresses"),
                h.button({
                    class: "btn-close bg-light rounded-circle p-2",
                    "data-bs-dismiss": "modal",
                    aria_label: "Close",
                }),
            ),
            v(uc.addresses, (addresses) => {
                if (addresses.value?.length === 0) {
                    return h.div(
                        { class: "text-center py-5 text-muted" },
                        h.i({
                            class: "fas fa-map-location-dot fa-3x mb-3 opacity-50",
                        }),
                        h.p("No addresses saved yet."),
                    );
                }

                // If no selection is made yet, default to the last chosen address
                if (
                    this.selectedAddressId.value === null &&
                    addresses.value.length > 0
                ) {
                    this.selectedAddressId.value =
                        addresses.value[addresses.value.length - 1].id;
                }

                return h.div(
                    {
                        class: "d-flex flex-column gap-3 mb-4",
                        style: "max-height: 50vh; overflow-y: auto;",
                    },
                    addresses?.value?.map((address) => {
                        return v(this.selectedAddressId, (selectedId) => {
                            const isSelected = selectedId.value === address.id;
                            return h.div(
                                {
                                    class: `card border-2 rounded-4 p-3 mb-1 position-relative cursor-pointer ${
                                        isSelected
                                            ? "border-primary bg-light"
                                            : "border-light bg-white"
                                    }`,
                                    data_address_card_id: address.id,
                                    listeners: {
                                        click: () => {
                                            this.selectedAddressId.value =
                                                address.id;
                                        },
                                    },
                                },
                                h.div(
                                    {
                                        class: "d-flex justify-content-between align-items-center mb-2",
                                    },
                                    h.div(
                                        {
                                            class: "d-flex align-items-center gap-2",
                                        },
                                        // Delete Icon
                                        h.button(
                                            {
                                                class: "btn btn-link text-danger p-0 border-0 me-1",
                                                listeners: {
                                                    click: (e) => {
                                                        e.stopPropagation();
                                                        broker.send(
                                                            $e.deliveryAddress
                                                                .needs.deletion,
                                                            payload({
                                                                id: address.id,
                                                            }),
                                                        );
                                                    },
                                                },
                                            },
                                            h.i({ class: "fas fa-trash-can" }),
                                        ),
                                        h.h6(
                                            {
                                                class: "fw-bold text-muted text-uppercase small mb-0",
                                            },
                                            "Delivery Location",
                                        ),
                                    ),
                                    h.div(
                                        {
                                            class: "d-flex align-items-center gap-2",
                                        },
                                        // Actual Select Button
                                        h.button(
                                            {
                                                class: `btn btn-sm rounded-pill fw-semibold py-1 px-3 ${
                                                    isSelected
                                                        ? "btn-primary"
                                                        : "btn-outline-secondary"
                                                }`,
                                                type: "button",
                                                listeners: {
                                                    click: (e) => {
                                                        e.stopPropagation();
                                                        this.selectedAddressId.value =
                                                            address.id;
                                                    },
                                                },
                                            },
                                            isSelected ? "Selected" : "Select",
                                        ),
                                    ),
                                ),
                                // Actual address text below header row - icon and text in separate divs, margin left removed
                                h.div(
                                    {
                                        class: "d-flex align-items-start gap-2 fw-bold text-dark fs-6 mb-3",
                                    },
                                    h.div(
                                        h.i({
                                            class: "fas fa-map-pin text-primary mt-1",
                                        }),
                                    ),
                                    h.div(
                                        { class: "flex-grow-1" },
                                        address.address,
                                    ),
                                ),
                                // Secondary info container - margin left removed
                                h.div(
                                    { class: "py-2 px-3 bg-light rounded-3" },
                                    address.recipient_name || address.phone
                                        ? [
                                              either(
                                                  address.recipient_name,
                                                  () =>
                                                      h.div(
                                                          {
                                                              class: "d-flex align-items-center gap-2 mb-1",
                                                          },
                                                          h.i({
                                                              class: "fas fa-user text-muted small",
                                                          }),
                                                          h.span(
                                                              {
                                                                  class: "fw-medium text-dark small",
                                                              },
                                                              address.recipient_name,
                                                          ),
                                                      ),
                                              ),
                                              either(address.phone, () =>
                                                  h.div(
                                                      {
                                                          class: "d-flex align-items-center gap-2 mb-1",
                                                      },
                                                      h.i({
                                                          class: "fas fa-phone text-muted small",
                                                      }),
                                                      h.span(
                                                          {
                                                              class: "fw-medium text-dark small",
                                                          },
                                                          address.phone,
                                                      ),
                                                  ),
                                              ),
                                          ]
                                        : address.first_name ||
                                            address.last_name ||
                                            address.phone
                                          ? [
                                                either(
                                                    address.first_name ||
                                                        address.last_name,
                                                    () =>
                                                        h.div(
                                                            {
                                                                class: "d-flex align-items-center gap-2 mb-1",
                                                            },
                                                            h.i({
                                                                class: "fas fa-user text-muted small",
                                                            }),
                                                            h.span(
                                                                {
                                                                    class: "fw-medium text-dark small",
                                                                },
                                                                `${[address.first_name, address.last_name].filter(Boolean).join(" ")}`,
                                                            ),
                                                        ),
                                                ),
                                                either(address.phone, () =>
                                                    h.div(
                                                        {
                                                            class: "d-flex align-items-center gap-2 mb-1",
                                                        },
                                                        h.i({
                                                            class: "fas fa-phone text-muted small",
                                                        }),
                                                        h.span(
                                                            {
                                                                class: "fw-medium text-dark small",
                                                            },
                                                            address.phone,
                                                        ),
                                                    ),
                                                ),
                                            ]
                                          : h.empty(),
                                    either(address.additional_information, () =>
                                        h.div(
                                            {
                                                class: "d-flex align-items-start gap-2 small text-secondary",
                                            },
                                            either(
                                                address.recipient_name ||
                                                    address.phone ||
                                                    address.first_name ||
                                                    address.last_name,
                                                {
                                                    class: "pt-2 border-top mt-2 w-100 d-flex align-items-start gap-2",
                                                },
                                                {
                                                    class: "w-100 d-flex align-items-start gap-2",
                                                },
                                            ),
                                            h.i({
                                                class: "fas fa-info-circle text-muted",
                                            }),
                                            h.span(
                                                address.additional_information,
                                            ),
                                        ),
                                    ),
                                ),
                            );
                        });
                    }),
                );
            }),
            h.div(
                { class: "border-top pt-3 w-100" },
                h.button(
                    {
                        class: "btn btn-dark rounded-pill fw-bold w-100 py-3",
                        type: "button",
                        onclick: this.method("confirmSelectedAddress"),
                    },
                    "Use This Address",
                ),
            ),
        );
    }

    $$deliveryAddress = {
        needs: {
            addressList: (ed, event) => {
                if (!requireAuth("Sign in to manage your addresses")) return;
                this.showList(ed, event);
            },
            closeAddressList: () => this.closeList(),
        },
        stored: () => {
            // Reset selection to the newly stored address if any
            if (uc.addresses.value.length > 0) {
                this.selectedAddressId.value =
                    uc.addresses.value[uc.addresses.value.length - 1].id;
            }
        },
        deleted: () => {
            // Reset selection if the currently selected one was deleted
            const addressExists = uc.addresses.value.some(
                (a) => a.id === this.selectedAddressId.value,
            );
            if (!addressExists && uc.addresses.value.length > 0) {
                this.selectedAddressId.value =
                    uc.addresses.value[uc.addresses.value.length - 1].id;
            } else if (uc.addresses.value.length === 0) {
                this.selectedAddressId.value = null;
            }
        },
    };

    showList(ed, event) {
        if (this.modal) {
            cleanDispose(this.modal);
        }

        // Set initial selected address to current selected address
        if (uc.addresses.value.length > 0) {
            this.selectedAddressId.value =
                uc.addresses.value[uc.addresses.value.length - 1].id;
        }

        const modalContent = h.div(
            { class: "modal-content border-0 rounded-4 shadow-lg" },
            h.div({ class: "modal-body p-4" }, this.renderList()),
        );

        this.modal = tool.plainModal(modalContent);
        this.modal.show();

        // Scroll selected address into view after modal transitions open
        setTimeout(() => {
            if (this.selectedAddressId.value) {
                const targetCard = document.querySelector(
                    `[data-address-card-id="${this.selectedAddressId.value}"]`,
                );
                if (targetCard) {
                    targetCard.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                    });
                }
            }
        }, 300);
    }

    closeList() {
        if (this.modal) {
            this.modal.hide();
        }
    }

    confirmSelectedAddress() {
        const address = uc.addresses.value.find(
            (a) => a.id === this.selectedAddressId.value,
        );
        if (address) {
            broker.send($e.deliveryAddress.selected, payload({ address }));
        }
        this.closeList();
    }
}

ojs(DeliveryAddressList);
